import {useCallback, useEffect, useState} from 'react'
import {useAppDispatch, useAppSelector} from 'src/redux/storeHooks'
import {getTopStockedItemsAsync} from 'src/redux/actions/authActions'
import {DashboardPeriodFilter} from '../utils/dashboardPeriodUtils'

export type TopStockedItemRow = {
  id: number
  name: string
  sku: string
  value: number | string
}

type TopStockedItemApi = {
  product_variant_id: number
  product_name: string
  sku: string
  value: number | string
}

export const useTopStockedItems = (period: DashboardPeriodFilter) => {
  const dispatch = useAppDispatch()
  const {fetchedUserAccountData, fetchedUserAccountLoading} = useAppSelector(
    (state) => state.userAccountData
  )
  const [rows, setRows] = useState<TopStockedItemRow[]>([])
  const [loading, setLoading] = useState(false)

  const fetchTopStocked = useCallback(async () => {
    if (fetchedUserAccountLoading || !fetchedUserAccountData?.id) return

    setLoading(true)

    try {
      const res = await dispatch(
        getTopStockedItemsAsync({
          user_id: fetchedUserAccountData.id,
          view_by: 'quantity',
          filter_type: period,
          page_num: 1,
          page_limit: 10,
        })
      )

      const items: TopStockedItemApi[] =
        res.payload?.status_code === 200 && Array.isArray(res.payload?.data?.items)
          ? res.payload.data.items
          : []

      setRows(
        items.map((item) => ({
          id: item.product_variant_id,
          name: item.product_name || 'Unknown item',
          sku: item.sku || '—',
          value: item.value ?? '—',
        }))
      )
    } catch {
      setRows([])
    } finally {
      setLoading(false)
    }
  }, [dispatch, fetchedUserAccountData?.id, fetchedUserAccountLoading, period])

  useEffect(() => {
    fetchTopStocked()
  }, [fetchTopStocked])

  return {rows, loading}
}
